document.addEventListener('DOMContentLoaded',()=>{const b=document.querySelector('.menu-btn'),m=document.querySelector('.mobile-links');if(b&&m)b.addEventListener('click',()=>{m.hidden=!m.hidden;b.setAttribute('aria-expanded',String(!m.hidden))})});
// Manually controlled product image slider (no autoplay).
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-nure-gallery]').forEach(gallery=>{
    const slides=Array.from(gallery.querySelectorAll('[data-slide]'));
    if(slides.length<2)return;
    const current=gallery.querySelector('[data-gallery-current]');
    let index=0;
    const show=(next)=>{
      index=(next+slides.length)%slides.length;
      slides.forEach((slide,i)=>{
        const active=i===index;
        slide.classList.toggle('is-active',active);
        slide.setAttribute('aria-hidden',String(!active));
      });
      if(current)current.textContent=String(index+1);
    };
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>show(index-1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click',()=>show(index+1));
    let startX=null,startY=null;
    gallery.addEventListener('touchstart',e=>{
      if(e.touches.length!==1)return;
      startX=e.touches[0].clientX;startY=e.touches[0].clientY;
    },{passive:true});
    gallery.addEventListener('touchend',e=>{
      if(startX===null||!e.changedTouches.length)return;
      const dx=e.changedTouches[0].clientX-startX;
      const dy=e.changedTouches[0].clientY-startY;
      startX=null;startY=null;
      if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.2)show(index+(dx<0?1:-1));
    },{passive:true});
  });
});
